import { ChangeDetectionStrategy, Component, input, InputSignal, OnDestroy, OnInit, output, OutputEmitterRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { FilterPanelConfig, FilterPanelData } from './_config/filter-panel.model';
import { BaseComponent } from '@/app/components/common/baseComponent/base.component';
import { FormPlycaComponent } from '@/app/components/forms/formPlyca.component';
import { FormConfig } from '@/app/components/forms/form.objects';
import { PlycaUiCollapsablePanelComponent } from '../../panels/collapsable-panel/collapsable-panel.component';

@Component({
  selector: 'plyca-ui-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrl: './filter-panel.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiCollapsablePanelComponent, FormPlycaComponent]
})
export class PlycaUiFilterPanelComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('formPlycaRef') formPlycaRef: FormPlycaComponent;

  public formConfig: FormConfig;
  public config: InputSignal<FilterPanelConfig> = input.required<FilterPanelConfig>();
  public valuesFormChange: OutputEmitterRef<FilterPanelData> = output<FilterPanelData>();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.dtoToModel();
  }

  public dtoToModel(): void {
    if (this.config().isFormPlyca) {
      this.subscribe(this.setJson().pipe(take(1)), (form: FormConfig) => {
        if (form) {
          const adaptedConfig = this.config()?.formConfigAdapted ?? {};
          this.formConfig = { ...form, ...adaptedConfig };
          this.valuesFormChange.emit({ isLoaded: true, formPlycaRef: this.formPlycaRef, formConfig: this.formConfig });
        }
      });
    }
  }

  private setJson(): Observable<FormConfig> {
    if (!this.config().jsonFile) {
      return;
    }
    return of(new FormConfig(undefined, this.config().jsonFile, this.config().model));
  }

  public onValueChange(event: FilterPanelData): void {
    this.valuesFormChange.emit({ ...event, formPlycaRef: this.formPlycaRef, formConfig: this.formConfig });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
